module.exports = __webpack_public_path__ + "img/revexpo_1896.c486dfb9.jpg";